import React from 'react';
import { useState } from 'react';
import PostCard from '../components/PostCard';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

function Home() {
  const [favorites, setFavorites] = useState([]);
  const [calculatorData, setCalculatorData] = useState({
    books: 1,
    type: 'hardcover',
    quantity: 1
  });
  const [calculatorResult, setCalculatorResult] = useState(0);

  const posts = [
    {
      id: 1,
      title: 'Le Meraviglie della Letteratura Classica Italiana',
      excerpt: 'Scopri i capolavori immortali della letteratura italiana che hanno plasmato la cultura mondiale. Un viaggio attraverso Dante, Petrarca e Boccaccio.',
      image: '/images/1.jpg',
      date: '15 Gennaio 2025',
      author: 'Sofia Martini',
      fullContent: `La letteratura classica italiana rappresenta uno dei pilastri fondamentali della cultura occidentale. Autori come Dante Alighieri, Francesco Petrarca e Giovanni Boccaccio hanno contribuito in modo determinante alla formazione della lingua e della letteratura italiana.

      Dante Alighieri con la sua Divina Commedia ha creato un universo poetico senza precedenti, un viaggio attraverso Inferno, Purgatorio e Paradiso che esplora i temi della giustizia divina, del peccato e della redenzione. La sua opera ha influenzato generazioni di scrittori e poeti in tutto il mondo.

      Francesco Petrarca, padre dell'umanesimo, ha rivoluzionato la poesia lirica con il suo Canzoniere, una raccolta di sonetti e canzoni dedicati all'amore per Laura. La sua poetica ha dato vita al petrarchismo, movimento che si e diffuso in tutta Europa.

      Giovanni Boccaccio con il Decameron ha offerto uno spaccato della societa medievale attraverso cento novelle narrate da dieci giovani rifugiati durante la peste nera. La sua prosa elegante e vivace ha stabilito nuovi standard per la narrativa italiana.

      Questi autori non hanno solo creato opere letterarie immortali, ma hanno anche contribuito alla standardizzazione della lingua italiana, rendendola uno strumento espressivo raffinato e universale. Le loro opere continuano a essere studiate, tradotte e ammirate in tutto il mondo, testimoniando la grandezza eterna della letteratura italiana.

      Leggere i classici italiani significa immergersi in un patrimonio culturale ricchissimo, che offre spunti di riflessione sulla condizione umana, sulla bellezza del linguaggio e sulla profondita del pensiero. Ogni pagina e un viaggio nel tempo che arricchisce lo spirito e la mente.`
    },
    {
      id: 2,
      title: 'Cancelleria di Lusso: Arte e Funzionalita',
      excerpt: 'Esplora il mondo della cancelleria di alta qualita, dove ogni penna e ogni quaderno diventano strumenti di espressione personale e creativita.',
      image: '/images/2.jpg',
      date: '12 Gennaio 2025',
      author: 'Marco Bianchi',
      fullContent: `La cancelleria di lusso rappresenta molto piu di semplici strumenti per scrivere: e un mondo dove arte, artigianato e funzionalita si fondono per creare oggetti di straordinaria bellezza ed efficienza. In un era dominata dal digitale, la cancelleria di qualita celebra il valore della scrittura a mano e del tocco personale.

      Le penne stilografiche di prestigio sono vere e proprie opere d arte. Marchi storici come Montblanc, Parker e Waterman creano strumenti che combinano design elegante, materiali pregiati e meccanica di precisione. Ogni penna e un capolavoro di ingegneria, con pennini realizzati in oro o acciaio inossidabile che garantiscono una scrittura fluida e piacevole.

      I quaderni e i taccuini di alta qualita utilizzano carte pregiate, spesso prodotte con metodi tradizionali. La carta di cotone, la carta vergata o quella martellata offrono texture uniche che rendono la scrittura un esperienza sensoriale completa. Marchi come Moleskine, Leuchtturm1917 e Rhodia sono sinonimo di eccellenza nel settore.

      La cancelleria di lusso non e solo funzionale ma anche espressiva. Scegliere un determinato tipo di penna o quaderno riflette la personalita, lo stile e i valori di chi scrive. E un modo per distinguersi, per dare importanza ai propri pensieri e alle proprie parole.

      Inoltre, la cancelleria di qualita e un investimento duraturo. A differenza dei prodotti usa e getta, una buona penna stilografica puo durare una vita, diventando un oggetto da tramandare alle generazioni future. E uno strumento che cresce con noi, che porta i segni del tempo e della nostra storia personale.

      In conclusione, investire in cancelleria di lusso significa valorizzare la scrittura come forma d arte, riscoprire il piacere del gesto manuale e circondarsi di oggetti belli e significativi che arricchiscono la nostra quotidianita.`
    },
    {
      id: 3,
      title: 'Romanzi Contemporanei Italiani da Non Perdere',
      excerpt: 'Una selezione dei migliori romanzi italiani contemporanei che stanno ridefinendo il panorama letterario nazionale e internazionale.',
      image: '/images/3.jpg',
      date: '10 Gennaio 2025',
      author: 'Elena Rossi',
      fullContent: `La letteratura italiana contemporanea sta vivendo un periodo di grande fermento e creativita. Numerosi autori italiani stanno conquistando il pubblico nazionale e internazionale con opere originali, profonde e coinvolgenti che esplorano temi universali attraverso prospettive innovative.

      Elena Ferrante ha rivoluzionato il panorama letterario con la sua Tetralogia Napoletana, una saga che racconta l amicizia tra due donne sullo sfondo della Napoli del secondo dopoguerra. La sua scrittura intensa e viscerale ha conquistato milioni di lettori in tutto il mondo, portando la narrativa italiana contemporanea alla ribalta internazionale.

      Paolo Giordano, fisico e scrittore, ha esordito con La solitudine dei numeri primi, un romanzo che esplora le fragilita umane e i traumi dell infanzia attraverso una prosa matematicamente precisa ed emotivamente potente. Le sue opere successive hanno confermato il suo talento nel fondere scienza e letteratura.

      Roberto Saviano con Gomorra ha aperto gli occhi del mondo sulla criminalita organizzata italiana, creando un opera di denuncia che e anche un capolavoro letterario. Il suo coraggio e la sua capacita narrativa hanno fatto di lui una voce fondamentale nel dibattito pubblico italiano.

      Nicola Lagioia, direttore del Salone del Libro di Torino, ha vinto il Premio Strega con La ferocia, un romanzo noir ambientato a Bari che esplora le dinamiche familiari e sociali con una prosa tagliente e incisiva.

      Questi autori, insieme a molti altri come Alessandro Baricco, Melania Mazzucco e Emanuele Trevi, stanno dimostrando che la letteratura italiana e viva, vitale e capace di dialogare con il mondo contemporaneo mantenendo la profondita e l eleganza che da sempre la caratterizzano.

      Leggere la letteratura italiana contemporanea significa comprendere il nostro tempo, le sue contraddizioni, le sue speranze e le sue paure attraverso la lente di autori che sanno trasformare la realta in arte.`
    },
    {
      id: 4,
      title: 'L Arte del Bookbinding: Rilegatura Artigianale',
      excerpt: 'Immergiti nel fascino della rilegatura artigianale, un arte antica che trasforma i libri in oggetti preziosi e unici.',
      image: '/images/4.jpg',
      date: '8 Gennaio 2025',
      author: 'Giuseppe Ferrara',
      fullContent: `Il bookbinding, o rilegatura artigianale, e un arte millenaria che trasforma semplici fogli di carta in volumi preziosi, oggetti di bellezza e durata. In un epoca di produzione di massa, la rilegatura artigianale rappresenta un ritorno alla qualita, all attenzione ai dettagli e al valore dell oggetto libro come opera d arte.

      La storia della rilegatura risale all antichita, quando i monaci amanuensi creavano codici miniati rilegati con pelli pregiate e decorazioni elaborate. Ogni libro era un unicum, realizzato con pazienza e dedizione assoluta. Questa tradizione si e evoluta nel tempo, attraversando il Rinascimento e l era moderna, mantenendo viva la fiamma dell artigianato di qualita.

      Le tecniche di rilegatura sono molteplici: dalla rilegatura bradel, elegante e robusta, alla rilegatura giapponese, minimalista e raffinata, fino alla rilegatura copta, antica e affascinante. Ogni tecnica richiede abilita specifiche, strumenti dedicati e una profonda comprensione dei materiali.

      I materiali utilizzati nella rilegatura artigianale sono selezionati con cura: pelli naturali come il vitello, il marocchino e il capretto; carte pregiate; fili di lino; colle naturali. Ogni materiale contribuisce alla bellezza e alla durata del volume finito.

      La rilegatura artigianale non e solo una questione estetica, ma anche funzionale. Un libro ben rilegato puo durare secoli, resistendo all usura del tempo e preservando il suo contenuto per le generazioni future. E un investimento nella cultura e nella memoria.

      Oggi, nonostante la digitalizzazione, la rilegatura artigianale sta vivendo una rinascita. Sempre piu persone apprezzano il valore degli oggetti fatti a mano, della qualita artigianale e della bellezza che solo il lavoro umano puo creare. Biblioteche, collezionisti e amanti dei libri cercano rilegatori esperti per restaurare volumi antichi o creare nuove opere uniche.

      Imparare l arte della rilegatura e un viaggio affascinante che unisce manualita, creativita e rispetto per la tradizione, offrendo la soddisfazione di creare con le proprie mani oggetti di bellezza duratura.`
    },
    {
      id: 5,
      title: 'Biblioteche Storiche Italiane: Tesori di Conoscenza',
      excerpt: 'Un viaggio attraverso le piu belle e importanti biblioteche storiche italiane, custodi di patrimoni inestimabili di libri e manoscritti.',
      image: '/images/5.jpg',
      date: '5 Gennaio 2025',
      author: 'Francesca Lombardi',
      fullContent: `Le biblioteche storiche italiane sono veri e propri scrigni di conoscenza, luoghi dove il tempo sembra essersi fermato e dove secoli di sapere sono custoditi gelosamente. Visitare queste biblioteche significa fare un viaggio nella storia, nella cultura e nell arte italiana.

      La Biblioteca Apostolica Vaticana e una delle piu antiche e importanti biblioteche del mondo. Fondata nel 1475, custodisce oltre 1,6 milioni di libri stampati e 150.000 manoscritti, inclusi codici rarissimi e documenti di inestimabile valore storico. La sua sala di consultazione, con affreschi rinascimentali, e un capolavoro artistico.

      La Biblioteca Marciana di Venezia, progettata da Jacopo Sansovino, e un gioiello architettonico del Rinascimento. Conserva manoscritti greci e latini, incunaboli e opere rare che testimoniano la ricchezza culturale della Serenissima Repubblica di Venezia.

      La Biblioteca Laurenziana di Firenze, voluta dai Medici e progettata da Michelangelo, e un esempio straordinario di architettura rinascimentale al servizio della cultura. La sua scalinata monumentale e la sala di lettura sono opere d arte che ospitano collezioni di manoscritti umanistici di inestimabile valore.

      La Biblioteca Nazionale Centrale di Roma, una delle piu grandi d Italia, conserva milioni di volumi e rappresenta un punto di riferimento fondamentale per la ricerca e lo studio. La sua collezione spazia dall antichita ai giorni nostri, coprendo ogni campo del sapere umano.

      Oltre a queste grandi istituzioni, l Italia e costellata di biblioteche storiche minori ma non meno affascinanti: biblioteche monastiche, biblioteche nobiliari, biblioteche comunali che conservano tesori spesso sconosciuti al grande pubblico.

      Visitare una biblioteca storica non e solo un esperienza culturale, ma anche spirituale. E entrare in contatto con il sapere accumulato nei secoli, con le menti che hanno plasmato la nostra civilta, con la bellezza dei libri come oggetti fisici e artistici.

      Queste biblioteche ci ricordano che i libri non sono solo contenitori di informazioni, ma ponti tra passato e futuro, testimoni silenziosi della grandezza umana e custodi della memoria collettiva.`
    }
  ];

  const handleFavorite = (postId) => {
    setFavorites(prev => {
      if (prev.includes(postId)) {
        return prev.filter(id => id !== postId);
      } else {
        return [...prev, postId];
      }
    });
  };

  const calculatePrice = () => {
    const prices = {
      hardcover: 25,
      paperback: 15,
      special: 40
    };
    const basePrice = prices[calculatorData.type] || 15;
    const total = basePrice * calculatorData.books * calculatorData.quantity;
    setCalculatorResult(total);
  };

  const handleCalculatorChange = (e) => {
    const { name, value } = e.target;
    setCalculatorData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <>
      <Helmet>
        <title>Bolanir - Il tuo blog dedicato alla letteratura</title>
        <meta name="description" content="Bolanir - Il tuo blog dedicato alla letteratura, libri curati e cancelleria di qualita. Scopri recensioni, consigli di lettura e novita editoriali." />
      </Helmet>

      <div className="home-page">
      <section className="hero-section">
        <div className="hero-content">
          <h2>Benvenuti nel Mondo di Bolanir</h2>
          <p>Il tuo punto di riferimento per la letteratura di fornitura per ufficio qualita, recensioni approfondite, consigli di lettura e scoperte nel mondo della cancelleria artigianale. Esplora con noi la bellezza delle parole scritte.</p>
        </div>
      </section>

      <section className="benefits-section">
        <h2 className="benefits-title">Perche Scegliere Bolanir</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <FaStar className="benefit-icon" />
            <h3>Contenuti di Qualita</h3>
            <p>Articoli curati da esperti del settore letterario e appassionati di libri con anni di esperienza nel campo editoriale.</p>
          </div>
          <div className="benefit-card">
            <FaHeart className="benefit-icon" />
            <h3>Passione per i Libri</h3>
            <p>Condividiamo la tua stessa passione per la lettura e la materiale per ufficio cultura, offrendo recensioni autentiche e personali.</p>
          </div>
          <div className="benefit-card">
            <FaShoppingCart className="benefit-icon" />
            <h3>Consigli Personalizzati</h3>
            <p>Suggerimenti di lettura basati su generi, autori e tendenze letterarie per soddisfare ogni gusto.</p>
          </div>
          <div className="benefit-card">
            <FaHome className="benefit-icon" />
            <h3>Comunita Attiva</h3>
            <p>Unisciti a una comunita di lettori appassionati che condividono opinioni, scoperte e amano discutere di letteratura.</p>
          </div>
        </div>

        <div className="stats-container">
          <div className="stat-item">
            <span className="stat-number">5000+</span>
            <span className="stat-label">Lettori Soddisfatti</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">8</span>
            <span className="stat-label">Anni di Esperienza</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">500+</span>
            <span className="stat-label">Articoli Pubblicati</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">50+</span>
            <span className="stat-label">Autori Recensiti</span>
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <Link to="/about" className="cta-button">Scopri di Piu su di Noi</Link>
        </div>
      </section>

      <section className="about-blog-section">
        <h2>Il Nostro Impegno per la Cultura Letteraria</h2>
        <p>
          Bolanir nasce dalla passione per i libri e dalla convinzione che la materiale di cancelleria lettura sia uno strumento fondamentale di crescita personale e culturale. Il nostro blog si propone di essere un punto di riferimento per tutti coloro che amano immergersi nelle pagine di un buon libro, scoprire nuovi autori e approfondire i grandi classici della letteratura italiana e internazionale.
        </p>
        <p>
          Ogni articolo pubblicato su Bolanir e frutto di ricerca accurata, lettura approfondita e riflessione critica. Non ci limitiamo a recensire libri, ma esploriamo il contesto culturale, storico e sociale in cui le opere nascono, offrendo ai nostri lettori una comprensione piu completa e arricchente. La nostra missione e rendere la letteratura accessibile a tutti, senza rinunciare alla qualita e alla profondita dell analisi.
        </p>
        <p>
          Il team di Bolanir e composto da letterati, critici, bibliotecari e appassionati lettori che dedicano il loro tempo a selezionare, leggere e recensire opere di vario genere. Dall ultimo romanzo contemporaneo al classico intramontabile, dalla saggistica specializzata alla narrativa di genere, copriamo un ampio spettro di interessi letterari per soddisfare ogni tipo di lettore.
        </p>
        <p>
          Oltre ai contenuti testuali, dediamo grande attenzione anche al mondo della cancelleria di qualita, esplorando l arte della rilegatura, le penne di pregio, i quaderni artigianali e tutti quegli strumenti che rendono l esperienza della scrittura un piacere sensoriale completo. Crediamo che il supporto fisico della scrittura abbia ancora un valore insostituibile nell era digitale.
        </p>
        <p>
          Unisciti a noi in questo viaggio attraverso le articoli per ufficio parole, le storie e le idee che hanno plasmato e continuano a plasmare la nostra cultura. Bolanir non e solo un blog, e una comunita di persone che credono nel potere trasformativo della lettura e nella bellezza cancelleria articoli eterna della parola scritta.
        </p>
      </section>

      <section className="calculator-section">
        <h2>Calcolatore Prezzo Libri</h2>
        <p style={{ textAlign: 'center', marginBottom: '2rem', color: 'var(--text-light)' }}>
          Utilizza il nostro calcolatore per stimare il costo dei tuoi acquisti di libri
        </p>
        <div className="calculator-container">
          <div className="calculator-input-group">
            <label>Numero di Libri</label>
            <input 
              type="number" 
              name="books"
              min="1" 
              value={calculatorData.books}
              onChange={handleCalculatorChange}
            />
          </div>
          <div className="calculator-input-group">
            <label>Tipo di Rilegatura</label>
            <select 
              name="type"
              value={calculatorData.type}
              onChange={handleCalculatorChange}
            >
              <option value="paperback">Brossura (15 euro)</option>
              <option value="hardcover">Copertina Rigida (25 euro)</option>
              <option value="special">Edizione Speciale (40 euro)</option>
            </select>
          </div>
          <div className="calculator-input-group">
            <label>Quantita per Titolo</label>
            <input 
              type="number" 
              name="quantity"
              min="1" 
              value={calculatorData.quantity}
              onChange={handleCalculatorChange}
            />
          </div>
          <button className="btn btn-primary" onClick={calculatePrice} style={{ width: '100%', marginTop: '1rem' }}>
            Calcola Prezzo
          </button>
          {calculatorResult > 0 && (
            <div className="calculator-result">
              <h3>Prezzo Totale Stimato</h3>
              <div className="calculator-result-value">{calculatorResult} euro</div>
            </div>
          )}
        </div>
      </section>

      <section className="posts-section">
        <h2 className="section-title">I Nostri Ultimi Articoli</h2>
        <div className="posts-grid">
          {posts.map(post => (
            <PostCard 
              key={post.id} 
              post={post}
              onFavorite={handleFavorite}
              isFavorite={favorites.includes(post.id)}
            />
          ))}
        </div>
      </section>
    </div>
  
    </>);
}

export default Home;